// Action Types
export const FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST = "FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST";
export const FETCH_MEETING_PREP_PROMPTERS_CARD_SUCCESS = "FETCH_MEETING_PREP_PROMPTERS_CARD_SUCCESS";
export const FETCH_MEETING_PREP_PROMPTERS_CARD_FAILURE = "FETCH_MEETING_PREP_PROMPTERS_CARD_FAILURE";

// Action Creators
export const fetchMeetingPrepPromptersCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchMeetingPrepPromptersCardSuccess = (data) => ({
  type: FETCH_MEETING_PREP_PROMPTERS_CARD_SUCCESS,
  payload: data,
});
export const fetchMeetingPrepPromptersCardFailure = (error) => ({
  type: FETCH_MEETING_PREP_PROMPTERS_CARD_FAILURE,
  payload: error,
});
